import { Css } from "@homebound/beam";
import { Card } from "src/components/Card";
import { UserEventsFeed } from "src/routes/my-blueprint/activity-feed/UserEventsFeed";

type RecentActivityCardProps = { planPackageId: string; optionIds: string[]; programDataModificationIds: string[] };

export function RecentActivityCard({ planPackageId, optionIds, programDataModificationIds }: RecentActivityCardProps) {
  return (
    <Card xss={Css.p3.boxShadow("none").$}>
      <h3 css={Css.lg.mb2.$}>Recent Activity</h3>
      <UserEventsFeed
        parentIds={[planPackageId, ...optionIds, ...programDataModificationIds]}
        parentType={["rp", "rpo", "rpopdm"]}
      />
    </Card>
  );
}
